import { ChangeDetectionStrategy, ChangeDetectorRef, Component, input, Input, OnDestroy, OnInit } from "@angular/core";

import { WebhookFormInputComponent } from "../webhook-form-input/webhook-form-input.component";
import { WebhookCommonComponent } from "../common.components";

@Component({
    selector: 'webhook-form-select',
    templateUrl: './webhook-form-select.component.html',
    styleUrl: './webhook-form-select.component.scss',
    standalone: false
})

export class WebhookFormSelectComponent extends WebhookCommonComponent implements OnInit, OnDestroy {
   
    


}